<div [formGroup]="form">
  <!-- Row 1: Product Category -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="productCategory" class="form-label"
          >{{ labels.productCategory }} <span class="ast">*</span></label
        >
        <div class="multi-select-container">
          <div
            class="form-control multi-select-trigger"
            [class.is-invalid]="isFieldInvalid('productCategoryId')"
            (click)="toggleDropdown()"
          >
            <span class="multi-select-display">{{ getSelectedDisplay() }}</span>
            <span class="multi-select-arrow">&#9662;</span>
          </div>
          <div class="multi-select-dropdown" *ngIf="dropdownOpen">
            <div
              class="multi-select-option"
              *ngFor="let type of insuranceTypes"
              (click)="toggleSelection(type.ItemID)"
            >
              <input
                type="checkbox"
                [checked]="isSelected(type.ItemID)"
                (click)="$event.stopPropagation(); toggleSelection(type.ItemID)"
              />
              <span>{{ type.DisplayName }}</span>
            </div>
          </div>
        </div>
        <div class="invalid-feedback"
          *ngIf="isFieldInvalid('productCategoryId')"
          style="display: block"
        >
          {{ messages.fieldRequired }}
        </div>
      </div>
      <div
        class="form-group mb-3"
        *ngIf="isOtherSelected"
      >
        <label for="otherInsurance" class="form-label"
          >{{ labels.pleaseSpecify }} <span class="ast">*</span></label
        >
        <input
          type="text"
          id="otherInsurance"
          class="form-control"
          formControlName="otherInsurance"
          [class.is-invalid]="isFieldInvalid('otherInsurance')"
          placeholder="{{ placeholders.enterProductCat }}"
          maxlength="200"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('otherInsurance')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>
  </div>

  <!-- Selected Products -->
  <div class="row" *ngIf="getSelectedItems().length > 0">
    <div class="col-md-12">
      <div class="mb-3 selected-labels-container">
        <ng-container *ngFor="let item of getSelectedItems()">
          <span class="label-product">{{ item }}</span>
        </ng-container>

      </div>
    </div>
  </div>
  <br *ngIf="getSelectedItems().length > 0">


  <!-- Row 2: Description -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <label for="description" class="form-label"
          >{{ labels.describeRequest }} <span class="ast">*</span></label
        >
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
          [class.is-invalid]="isFieldInvalid('description')"
          rows="4"
          placeholder="{{ placeholders.describeYourRequest }}"
          maxlength="2000"
        ></textarea>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
          <span *ngIf="form.get('description')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
          <span *ngIf="form.get('description')?.hasError('minlength')">
            {{ messages.characterLimit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
